//Issue for Cutting
export const ALL_ISSUE_FOR_CUTTING_REQUEST = "ALL_ISSUE_FOR_CUTTING_REQUEST";
export const ALL_ISSUE_FOR_CUTTING_SUCCESS = "ALL_ISSUE_FOR_CUTTING_SUCCESS";
export const ALL_ISSUE_FOR_CUTTING_FAIL = "ALL_ISSUE_FOR_CUTTING_FAIL";

//Cutting Done
export const ALL_CUTTING_DONE_REQUEST = "ALL_CUTTING_DONE_REQUEST";
export const ALL_CUTTING_DONE_SUCCESS = "ALL_CUTTING_DONE_SUCCESS";
export const ALL_CUTTING_DONE_FAIL = "ALL_CUTTING_DONE_FAIL";

//Smoking
//issued For smoking Group
export const ALL_ISSUED_FOR_SMOKING_GROUPS_REQUEST =
  "ALL_ISSUED_FOR_SMOKING_GROUPS_REQUEST";
export const ALL_ISSUED_FOR_SMOKING_GROUPS_SUCCESS =
  "ALL_ISSUED_FOR_SMOKING_GROUPS_SUCCESS";
export const ALL_ISSUED_FOR_SMOKING_GROUPS_FAIL =
  "ALL_ISSUED_FOR_SMOKING_GROUPS_FAIL";

//smoked Individuals
export const ALL_SMOKED_INDIVIDUALS_REQUEST = "ALL_SMOKED_INDIVIDUALS_REQUEST";
export const ALL_SMOKED_INDIVIDUALS_SUCCESS = "ALL_SMOKED_INDIVIDUALS_SUCCESS";
export const ALL_SMOKED_INDIVIDUALS_FAIL = "ALL_SMOKED_INDIVIDUALS_FAIL";

//smoked Groups
export const ALL_SMOKED_GROUPS_REQUEST = "ALL_SMOKED_GROUPS_REQUEST";
export const ALL_SMOKED_GROUPS_SUCCESS = "ALL_SMOKED_GROUPS_SUCCESS";
export const ALL_SMOKED_GROUPS_FAIL = "ALL_SMOKED_GROUPS_FAIL";

// tapping

export const ALL_ISSUE_FOR_TAPPING_REQUEST = "ALL_ISSUE_FOR_TAPPING_REQUEST";
export const ALL_ISSUE_FOR_TAPPING_SUCCESS = "ALL_ISSUE_FOR_TAPPING_SUCCESS";
export const ALL_ISSUE_FOR_TAPPING_FAIL = "ALL_ISSUE_FOR_TAPPING_FAIL";


export const ALL_TAPPING_DONE_REQUEST = "ALL_TAPPING_DONE_REQUEST";
export const ALL_TAPPING_DONE_SUCCESS = "ALL_TAPPING_DONE_SUCCESS";
export const ALL_TAPPING_DONE_FAIL = "ALL_TAPPING_DONE_FAIL";


//Dying
//issued For Dying Group
export const ALL_ISSUED_FOR_DYING_GROUPS_REQUEST =
  "ALL_ISSUED_FOR_DYING_GROUPS_REQUEST";
export const ALL_ISSUED_FOR_DYING_GROUPS_SUCCESS =
  "ALL_ISSUED_FOR_DYING_GROUPS_SUCCESS";
export const ALL_ISSUED_FOR_DYING_GROUPS_FAIL =
  "ALL_ISSUED_FOR_DYING_GROUPS_FAIL";

//dyed Individuals
export const ALL_DYED_INDIVIDUALS_REQUEST = "ALL_DYED_INDIVIDUALS_REQUEST";
export const ALL_DYED_INDIVIDUALS_SUCCESS = "ALL_DYED_INDIVIDUALS_SUCCESS";
export const ALL_DYED_INDIVIDUALS_FAIL = "ALL_DYED_INDIVIDUALS_FAIL";

//dyed Groups
export const ALL_DYED_GROUPS_REQUEST = "ALL_DYED_GROUPS_REQUEST";
export const ALL_DYED_GROUPS_SUCCESS = "ALL_DYED_GROUPS_SUCCESS";
export const ALL_DYED_GROUPS_FAIL = "ALL_DYED_GROUPS_FAIL";


// pressing

export const ALL_ISSUE_FOR_PRESSING_REQUEST = "ALL_ISSUE_FOR_PRESSING_REQUEST";
export const ALL_ISSUE_FOR_PRESSING_SUCCESS = "ALL_ISSUE_FOR_PRESSING_SUCCESS";
export const ALL_ISSUE_FOR_PRESSING_FAIL = "ALL_ISSUE_FOR_PRESSING_FAIL";


export const ALL_PRESSING_DONE_REQUEST = "ALL_PRESSING_DONE_REQUEST";
export const ALL_PRESSING_DONE_SUCCESS = "ALL_PRESSING_DONE_SUCCESS";
export const ALL_PRESSING_DONE_FAIL = "ALL_PRESSING_DONE_FAIL";

// finishing

export const ALL_ISSUE_FOR_FINISHING_REQUEST = "ALL_ISSUE_FOR_FINISHING_REQUEST";
export const ALL_ISSUE_FOR_FINISHING_SUCCESS = "ALL_ISSUE_FOR_FINISHING_SUCCESS";
export const ALL_ISSUE_FOR_FINISHING_FAIL = "ALL_ISSUE_FOR_FINISHING_FAIL";


export const ALL_FINISHING_DONE_REQUEST = "ALL_FINISHING_DONE_REQUEST";
export const ALL_FINISHING_DONE_SUCCESS = "ALL_FINISHING_DONE_SUCCESS";
export const ALL_FINISHING_DONE_FAIL = "ALL_FINISHING_DONE_FAIL";